'use client'

import { SessionProvider } from 'next-auth/react'
import { ToastProvider } from '@/components/ui/toast'
import { CommandPalette } from '@/components/CommandPalette'
import { AIProvider } from '@/context/AIContext'
import { LanguageProvider } from '@/context/LanguageContext'

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider
      basePath={`${process.env.NEXT_PUBLIC_BASE_PATH || ''}/api/auth`}
      refetchInterval={4 * 60}
      refetchOnWindowFocus={true}
    >
      <LanguageProvider>
        <AIProvider>
          {children}
          <ToastProvider />
          <CommandPalette />
        </AIProvider>
      </LanguageProvider>
    </SessionProvider>
  )
}
